jQuery(document).ready(function($) {

    $('*[data-modal-target]').each(function() {
        let modalCommand = $(this)
        let modalId = modalCommand.data('modal-target')
        let modal = $('*[data-modal-id="'+modalId+'"]')

        let body = $('body')

        modal.click(function(e) {
            if (e.target.form === undefined) {
                modal.addClass('modal')
                modalCommand.show()
                body.removeClass('noscroll')
            }
        })

        modalCommand.click(function(e) {
            modalCommand.hide()
            modal.removeClass('modal')
            body.addClass('noscroll')
        }).children().click(function() {
            return false
        })

    });
});